import "./style.scss";
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const MOBILE_BREAKPOINT = 767;
const isMobile = window.innerWidth <= MOBILE_BREAKPOINT;

if (!isMobile) {
    gsap.to(".properties__sidebar-inner", {
        y: -240,
        ease: "none",
        scrollTrigger: {
            trigger: ".properties-content",
            start: "top bottom",
            end: "bottom top",
            scrub: true,
        },
    });
}